const roundDecimals = (dataToTransform, mode) => {
const roundData = dataToTransform.map((element) => {
    const {fecha, tiempo, ...rest} = element
    let decimalsValues = {}
    for (let key in rest){
            if(!isNaN(Math.abs(rest[key])) && rest[key] !== null && rest[key]>0){
                decimalsValues = {...decimalsValues, [key]:parseFloat(rest[key]).toFixed(2)}
            }else if(rest[key] === null){
                decimalsValues = {...decimalsValues, [key] : 'ND'}
            }
            else{
                decimalsValues = {...decimalsValues, [key] : rest[key]}
            }
    }
    if (mode === 'automatic') {
        return {fecha, tiempo, ...decimalsValues}
    } else {
        return {fecha, ...decimalsValues}
    }
})
return roundData
}
export default roundDecimals